import { combineReducers } from "redux";
import orgProfileData from "./orgProfile";
import parties from "../features/parties/partiesSlice";
import communicationData from "./communicationSlice";
import orgUserData from "../features/orgAccess/orgAccessSlice";
import noteSettingsData from "../features/noteSettings/noteSettingsSlice";
import orgProfileDetail from "../orgProfile/orgProfileSlice";
import usersData from "../features/users/usersSlice";
import relationships from "../features/relationships/relationshipsSlice";
export default combineReducers({
  orgProfileData,
  parties,
  communicationData,
  orgUserData,
  noteSettingsData,
  orgProfileDetail,
  usersData,
  relationships
});
